import { BasicEnumerable } from "../BasicEnumerable.js";
export const where = (source, predicate) => {
    if (predicate.length === 1) {
        return where1(source, predicate);
    }
    else {
        return where2(source, predicate);
    }
};
const where1 = (source, predicate) => {
    function* iterator() {
        for (const item of source) {
            if (predicate(item) === true) {
                yield item;
            }
        }
    }
    return new BasicEnumerable(iterator);
};
const where2 = (source, predicate) => {
    function* iterator() {
        let i = 0;
        for (const item of source) {
            if (predicate(item, i++) === true) {
                yield item;
            }
        }
    }
    return new BasicEnumerable(iterator);
};
